module.exports = __webpack_public_path__ + "img/vertical-condensed.a53efda2.jpg";